import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_org/settings/')({
  beforeLoad: async () => {
    throw redirect({ to: '/settings/profile' });
  },
});
